import {
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  PLATFORM_ID,
  SimpleChanges,
} from '@angular/core';
import { Auction } from '../../../buyer-modules/buyer-auctions/_interfaces/auction.interface';

import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { environment } from 'src/environments/environment';
import {
  NgIf,
  DecimalPipe,
  isPlatformBrowser,
  CommonModule,
  NgClass,
} from '@angular/common';
import { RequestToBidButtonComponent } from '../request-to-bid-button/request-to-bid-button.component';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { TimerComponent } from 'src/app/Shared/components/timer/timer.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { TermsConditionsUpdatedPopupComponent } from '../terms-conditions-updated-popup/terms-conditions-updated-popup.component';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  CardAction,
  CardAuthor,
  CardBadge,
  CardCountdown,
  CardImage,
  CardPedigree,
  CardPrice,
} from 'src/app/app-modules/buyer/buyer-shared/interfaces/auction-card';
import { CurrencySymbolPipe } from 'src/app/Shared/_pipes/currency-symbol/currency-symbol.pipe';
import { CustomCurrencyPipe } from 'src/app/Shared/_pipes/currency-pipe/custom-currency-pipe.pipe';
import { LocalizedNamePipe } from 'src/app/Shared/pipes/localized-name.pipe';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-buyer-auction-card',
  templateUrl: './buyer-auction-card-new.component.html',
  styleUrls: ['./buyer-auction-card.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    RequestToBidButtonComponent,
    CdkCopyToClipboard,
    DecimalPipe,
    TimerComponent,
    MatDialogModule,
    CommonModule,
    NgClass,
    TranslatePipe,
    LocalizedNamePipe,
    MatIconModule,
    MatProgressSpinner,
  ],
  providers: [CustomCurrencyPipe],
})
export class BuyerAuctionCardComponent {
  frontUrl = environment.url_front;
  @Input() darkTimer = false;
  @Input() auctionType!: string;
  @Input() showType: boolean = false;
  @Input() showViews: boolean = false;
  @Input() auction!: Auction;
  @Input() loggedIn!: boolean;
  /**
   * BXS-3589: signals that the buyer's per-auction application status has been
   * resolved. The "All Auctions" page renders cards from a cached static
   * endpoint and merges per-buyer status from a second request; until that
   * lands, the action button is replaced by a placeholder so an Approved or
   * Pending buyer never sees a flash of the wrong "Request to Bid" button.
   * Defaults to true so single-call pages render the button immediately.
   */
  @Input() statusReady: boolean = true;
  @Output() actionFired: EventEmitter<any> = new EventEmitter<any>();
  // @Input() buyer_accepted_seller_terms!: any;

  isBrowser!: boolean;
  isGradualLotsEnding: boolean = true;

  // Buyer status getters
  get isBlocked(): boolean {
    return this.auction?.buyer_status?.is_blocked === true;
  }

  get isSuspended(): boolean {
    return this.auction?.buyer_status?.is_suspended === true;
  }

  get isBlockedOrSuspended(): boolean {
    return this.isBlocked || this.isSuspended;
  }

  get sellerEmail(): string {
    return this.auction?.seller?.user?.email || '';
  }

  /**
   * BXS-3589: true once the action button can be shown without risking a wrong
   * state — i.e. for guests (no per-buyer status exists) or once `statusReady`.
   */
  get isStatusResolved(): boolean {
    return !this.loggedIn || this.statusReady;
  }

  //////////////////////////////////////////////////////////

  @Output() cardClicked = new EventEmitter<void>();
  constructor(
    private router: Router,
    private toastService: ToastService,
    @Inject(PLATFORM_ID) private platformId: any,
    private dialog: MatDialog,
    private translate: TranslateService, // public dialogRef: MatDialogRef<TermsConditionsUpdatedPopupComponent>
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  ngOnInit() {}

  fireTimeEnded() {
    this.actionFired.emit({
      action: 'time_ended',
      data: this.auction,
    });
  }

  openUpdatedTermsAndConditions(event: Event) {
    event.stopPropagation();

    this.dialog
      .open(TermsConditionsUpdatedPopupComponent, {
        width: '520px',
        panelClass: ['buyer-theme'],

        data: {
          data: {},
        },
      })
      .afterClosed()
      .subscribe(() => {
        // this.dialogRef.close(true);
      });
  }
  testEnded(e: any) {
    // e.preventDefault();
    e.stopPropagation();

    this.actionFired.emit({ action: 'time_ended', data: this.auction });
  }

  loadData() {
    this.actionFired.emit({ action: 'load_data' });
  }
  gotToSellerPage(e: any, id: any) {
    e.stopPropagation();
    this.router.navigate(['/buyer/sellers/seller-details', id]);
  }
  handleActions(e: any, action: string) {
    e.stopPropagation();
    this.actionFired.emit({ action, data: this.auction });
  }
  ngOnDestroy(): void {}
  cpy(e: any) {
    e.stopPropagation();
    this.toastService.showInfo(
      this.translate.instant('auction.copied_to_clipboard'),
    );
  }
  goToTermsAndConditions(event: any) {
    event.stopPropagation();
    const url = `/terms-and-conditions/auction/${this.auction?.id}`;
    window.open(url, '_blank');
  }

  onCardClick(): void {
    this.cardClicked.emit();
  }
}
